<template>
  <div class="eb-steps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "EbSteps",
  props: {
    active: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      steps: []
    };
  },
  watch: {
    active(newVal, oldVal) {
      this.$emit("change", newVal, oldVal);
    },
    steps(steps) {
      steps.forEach((child, index) => {
        child.index = index;
      });
    }
  }
};
</script>


<style lang="less" scoped>
.eb-steps {
  display: flex;
  justify-content: space-around;
}
</style>
